import { render, staticRenderFns } from "./EditModalAddress.vue?vue&type=template&id=d5908fc0&scoped=true"
import script from "./EditModalAddress.vue?vue&type=script&lang=js"
export * from "./EditModalAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5908fc0",
  null
  
)

export default component.exports